import { controls, currencyToNumber, grouped } from "../../controls";

const rpad3 = {
  label: "Branch Wise Audit",
  starting: true,
  url: "rp101m",
  pageLabel: "Branch Wise Audit",
  pageType: "history",
  filter: [

    ...controls.displayText({ tab: "general", label: "Bank", star: true }),
    ...controls.oc({ tab: "general", length: 4, c: "Client", placeHolder: "Bank Code", name: "client_code", isRequired: true, fastpath: "clients", clearData: ["branch_code"] }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "client_display" }),

    ...controls.displayText({ tab: "general", label: "Branch", star: true }),
    ...controls.oc({
      tab: "general", length: 4, c: "Branch", placeHolder: "Branch Code", name: "branch_code", isRequired: true, fastpath: "branches",
      sendToServer: { sendData: [{ varname: "client.client_uid", value: "client_uid" }] }
    }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "branch_display" }),

  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Branch Wise Audit",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: {
      pageSize: "A4", pageOrientation: "portrait",
      header: [
        [{ source: 'fixed', value: 'Bank:' }, { field: 'client_display', type: "capital" }, { source: 'fixed', value: '. Branch:' }, { field: 'branch_display', type: "capital" }],
        [{ source: 'history', field: 'reportHeader', type: "capital" }]
      ]
    },
    textReportProps: {
      'Recon': {
        filename: `Branch Wise Audit-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },

    extraRows: {
      location: "top",
      fields: ["observation_type"],
      subtotals: {
        by: "insgroup",
        displayIn: "observation_type",
        count: true
      }
      // grandtotal: { type: "fixed", displayIn: "pacs_name", val: "Grand Total", count: true },
    },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      // {
      //   Header: "Bank",
      //   accessor: "client_display",
      //   rwidth: "*"
      // },
      // {
      //   Header: "Branch",
      //   accessor: "branch_display",
      // },
      // {
      //   Header: "Type",
      //   accessor: "insgroup",
      // },
      // {
      //   Header: "Inspecting Officer",
      //   accessor: "auditor_display",
      // },
      {
        Header: "Observation",
        accessor: "observation_type",
        rwidth: "*"
      },
      {
        Header: "Inspection Date",
        accessor: "date",
        type: "date"
      },
      {
        Header: "Status",
        accessor: "inspection_status",
        back: (d) => ['In Progress', 'Not Completed / Not Available', 'Not Started'].indexOf(d['inspection_status']) != -1 ? "gray" : "white",
      },
      {
        Header: "Remark",
        accessor: "remark"
      },
      {
        Header: "Extended Deadline",
        accessor: "complete_by",
        type: "date"
      }
    ]
  }
};

export default rpad3;